<template>
  <div class="menuItem">
    <router-link class="name"
      :to="categoryRouteInfo(category.categoryId)"
      :data-depth="depth"
      :style="{color: colorDarken}"
      :class="{active: isActive(category.categoryId)}">
      {{ category.categoryLabel[lang] }}
    </router-link>
    <div v-if="category.subCategory && category.subCategory.length && depth < depthLimit" class="subMenu">
      <CollectionMegaMenuTree
        v-for="sub in category.subCategory"
        :key="sub.categoryId"
        :category="sub"
        :locale="locale"
        :lang="lang"
        :depth="depth + 1"
        :defaultFontColor="defaultFontColor"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'CollectionMegaMenuTree',
  props: [
    'locale',
    'lang',
    'category',
    'depth',
    'defaultFontColor'
  ],
  computed: {
    colorDarken () {
      return this.depth < 3 ? this.darkenRgba(this.defaultFontColor) : 'this.defaultFontColor'
    }
  },
  data () {
    return {
      depthLimit: 4
    }
  },
  methods: {
    darkenRgba (rgbaStr, percent = 0.3) {
      const match = rgbaStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/)
      if (!match) return rgbaStr // 파싱 실패하면 원래 값 반환

      let [_, r, g, b, a] = match
      r = Math.max(0, Math.floor(r * (1 - percent)))
      g = Math.max(0, Math.floor(g * (1 - percent)))
      b = Math.max(0, Math.floor(b * (1 - percent)))
      a = a !== undefined ? a : 1

      return `rgba(${r},${g},${b},${a})`
    },
    isActive (categoryId) {
      const currentCategoryId = this.$route.params.categoryId
      return currentCategoryId === categoryId
    },
    categoryRouteInfo (categoryId) {
      const categoryItem = this.category
      const categoryRouteName = categoryItem.useMain
        ? 'collectionCategoryMain'
        : 'collectionPage'
      return {
        name: categoryRouteName,
        params: {
          ...this.$route.params,
          categoryId: categoryId
        }
      }
    }
  }
}
</script>